<template>
    <div class="ibox playlog">
        <div class="ibox-content elevation-4" style="border-radius: 8px;">
            <h2 style="margin: 10px 10px 18px;">{{ t_title }}</h2>
            <table class="table table-striped table-bordered dataTable dtr-inline" aria-label="playlog table">
                <thead>
                <tr>
                    <th>{{ t_date }}</th>
                    <th>{{ t_screen }}</th>
                    <th>{{ t_filename }}</th>
                    <th>{{ t_duration }}</th>
                    <th>{{ t_fails }}</th>
                    <th>{{ t_repeats }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in rows" style="height: 50px;">
                    <td>
                        {{ row.displayed_date }}
                    </td>
                    <td>
                        {{ row.screen }}
                    </td>
                    <td v-html="row.filename"></td>
                    <td>
                        {{ row.duration }}
                    </td>
                    <td>
                        {{ row.fails }}
                    </td>
                    <td>
                        {{ row.repeats }}
                    </td>
                </tr>
                </tbody>
            </table>

            <div class="row no-margins p-h-xs" v-if="Object.keys(rows).length === 0">
                <div class="col-md-12 text-center">{{ t_no_data }}</div>
            </div>

            <client-detail-pagination
                    :page="page"
                    :pages="pages"
                    event="updatePlaylog"
            ></client-detail-pagination>
        </div>
    </div>
</template>
<script>
    import toaster from "../../common/toaster";

    export default {
        props: [
            'id',
            'limit'
        ],
        components: {
            clientDetailPagination: require('./pagination.vue').default,
        },
        data() {
            return {
                t_title: Lang.langGet("Playlog"),
                t_date: Lang.langGet("Date"),
                t_screen: Lang.langGet("Screen"),
                t_filename: Lang.langGet("Filename"),
                t_duration: Lang.langGet("Duration"),
                t_fails: Lang.langGet("Errors"),
                t_repeats: Lang.langGet("Played"),
                t_no_data: Lang.langGet("No data available."),
                t_playlog_load_error: Lang.langGet("Failed to load latest Playlog entries!"),
                rows: {},
                page: 0,
                pages: 0
            }
        },
        methods: {
            loadData: function () {
                axios.post('/system/client-detail/playlog', {
                    id: this.id,
                    page: this.page, limit: this.limit
                }).then((response) => {
                    this.rows = response.data.rows;
                    this.pages = response.data.pages;
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_playlog_load_error);
                });
            }
        },
        mounted() {
            this.loadData();

            EaseEventBus.listen('updatePlaylog', (data) => {
                this.page = data;
                this.loadData();
            });
        }
    }
</script>
